import { render, staticRenderFns } from "./FashionNicheIcon.vue?vue&type=template&id=61177ac3&scoped=true"
import script from "./FashionNicheIcon.vue?vue&type=script&lang=js"
export * from "./FashionNicheIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61177ac3",
  null
  
)

export default component.exports